import PerfectScrollbar from "react-perfect-scrollbar";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

function EmailTools() {
  return (
    <div className="mailbox">
      <div className="mailbox-toolbar">
        <div className="mailbox-toolbar-item">
          <span className="mailbox-toolbar-text">Deals</span>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/detail" className="mailbox-toolbar-link">
            Clientes
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/create" className="mailbox-toolbar-link">
            Entrevista
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/analytics" className="mailbox-toolbar-link">
            Analítica
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/tools" className="mailbox-toolbar-link active">
            Tools
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/contract" className="mailbox-toolbar-link">
            Contrato
          </Link>
        </div>
      </div>
      <div className="mailbox-body">
        <div className="mailbox-content">
          <PerfectScrollbar className="h-100">
            <div className="mailbox-detail">
              <div className="row gx-4">
                <div className="col-xl-3 col-md-6 py-3 py-xl-5">
                  <Card className="h-100">
                    <CardBody className="p-4 p-lg-5 d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <div className="flex-1">
                          <div className="h6 font-monospace mb-3">
                            Opción #1
                          </div>
                          <div className="display-6 mb-0 text-theme">
                            $1,253.36{" "}
                            <small className="h6 fw-light text-body text-opacity-50">
                              /mensualmente*
                            </small>
                          </div>
                        </div>
                        <div>
                          <Icon
                            className="display-4 text-theme"
                            icon="ph:package"
                          />
                        </div>
                      </div>
                      <hr className="my-4" />
                      <div className="mb-5 text-body text-opacity-50 flex-1">
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llantas
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llaves
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura amplia
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Tren motriz
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía de movilidad
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              GPS
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía extendida
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mx-n2">
                        <a
                          href="#/"
                          className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace"
                        >
                          Seleccionar <i className="fa fa-arrow-right"></i>
                        </a>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-xl-3 col-md-6 py-3 py-xl-5">
                  <Card className="h-100">
                    <CardBody className="p-4 p-lg-5 d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <div className="flex-1">
                          <div className="h6 font-monospace mb-3">
                            Opción #2
                          </div>
                          <div className="display-6 mb-0 text-theme">
                            $1,137.66{" "}
                            <small className="h6 fw-light text-body text-opacity-50">
                              /mensualmente*
                            </small>
                          </div>
                        </div>
                        <div>
                          <Icon
                            className="display-4 text-theme"
                            icon="ph:package"
                          />
                        </div>
                      </div>
                      <hr className="my-4" />
                      <div className="mb-5 text-body text-opacity-50 flex-1">
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llantas
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llaves
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura amplia
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Tren motriz
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía de movilidad
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              GPS
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía extendida
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mx-n2">
                        <a
                          href="#/"
                          className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace"
                        >
                          Seleccionar <i className="fa fa-arrow-right"></i>
                        </a>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-xl-3 col-md-6 py-3 py-xl-5">
                  <Card className="h-100">
                    <CardBody className="p-4 p-lg-5 d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <div className="flex-1">
                          <div className="h6 font-monospace mb-3">
                            Opción #3
                          </div>
                          <div className="display-6 mb-0 text-theme">
                            $1,105.22{" "}
                            <small className="h6 fw-light text-body text-opacity-50">
                              /mensualmente*
                            </small>
                          </div>
                        </div>
                        <div>
                          <Icon
                            className="display-4 text-theme"
                            icon="ph:package"
                          />
                        </div>
                      </div>
                      <hr className="my-4" />
                      <div className="mb-5 text-body text-opacity-50 flex-1">
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llantas
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llaves
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura amplia
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Tren motriz
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía de movilidad
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              GPS
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía extendida
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mx-n2">
                        <a
                          href="#/"
                          className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace"
                        >
                          Seleccionar <i className="fa fa-arrow-right"></i>
                        </a>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-xl-3 col-md-6 py-3 py-xl-5">
                  <Card className="h-100">
                    <CardBody className="p-4 p-lg-5 d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <div className="flex-1">
                          <div className="h6 font-monospace mb-3">
                            Opción #4
                          </div>
                          <div className="display-6 mb-0 text-theme">
                            $1,078.88{" "}
                            <small className="h6 fw-light text-body text-opacity-50">
                              /mensualmente*
                            </small>
                          </div>
                        </div>
                        <div>
                          <Icon
                            className="display-4 text-theme"
                            icon="ph:package"
                          />
                        </div>
                      </div>
                      <hr className="my-4" />
                      <div className="mb-5 text-body text-opacity-50 flex-1">
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llantas
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura de llaves
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-check fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Cobertura amplia
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Tren motriz
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía de movilidad
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              GPS
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa fa-times fa-lg text-body text-opacity-25"></i>
                          <div className="flex-1 ps-4">
                            <span className="font-monospace small text-body fw-semibold">
                              Garantía extendida
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mx-n2">
                        <a
                          href="#/"
                          className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace"
                        >
                          Seleccionar <i className="fa fa-arrow-right"></i>
                        </a>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
}

export default EmailTools;
